module.exports = __webpack_public_path__ + "static/media/math.172dd266.png";